import { render, staticRenderFns } from "./PaginaBilancioProgetti.vue?vue&type=template&id=1f402666"
import script from "./PaginaBilancioProgetti.vue?vue&type=script&lang=js"
export * from "./PaginaBilancioProgetti.vue?vue&type=script&lang=js"
import style0 from "./PaginaBilancioProgetti.vue?vue&type=style&index=0&id=1f402666&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports